import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Credit-card (Stripe) checkout is temporarily disabled. Flip to true to re-enable
// the card option once live Stripe keys are configured. Backend Stripe code is left intact.
export const CARD_PAYMENTS_ENABLED = false;

export const itemKey = (it) => `${it.label}|${it.detail || ""}|${it.amount}`;
export const personKey = (p) => `${p.name || `${p.first_name || ""} ${p.last_name || ""}`}|${p.dob || ""}|${p.subtotal ?? ""}`;
let _uid = 0;
export const uid = (prefix = "k") => `${prefix}-${Date.now()}-${++_uid}`;

const PROOF_TTL_MS = 30 * 60 * 1000;
const proofKey = (ref) => `proof_email_${ref}`;
export const rememberEmail = (ref, email) => {
  sessionStorage.setItem(proofKey(ref), JSON.stringify({ email, exp: Date.now() + PROOF_TTL_MS }));
};
export const rememberedEmail = (ref) => {
  try {
    const { email, exp } = JSON.parse(sessionStorage.getItem(proofKey(ref)) || "{}");
    if (email && exp > Date.now()) return email;
  } catch { /* malformed entry is treated as absent */ }
  sessionStorage.removeItem(proofKey(ref));
  return "";
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const usd = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(n || 0));

export const CAMP_DAY_LABELS = {
  9: "Jun 9", 10: "Jun 10", 11: "Jun 11", 12: "Jun 12", 13: "Jun 13",
};

export const SCP_LOGO = "https://customer-assets-eiarnc6j.emergentagent.net/job_camp-checkout-1/artifacts/hfwr3bzi_Sporting_Clube_de_Portugal_2026.svg.png";
export const NC_LOGO = "https://customer-assets-eiarnc6j.emergentagent.net/job_camp-checkout-1/artifacts/w5p8r3c9_nc_logo.png";
